import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../../api.service";
import { AuthService } from "../../../services/auth.service";
import {
  INotificationHistoryResponse,
  INotificationRecipientsResponse,
  ISendGeneralNotificationRequest,
  ISendNotificationResponse,
} from "./data/notification.models";

@Injectable({
  providedIn: "root",
})
export class NotificationsControllerService {
  private readonly resourceUrl = "/notifications";

  constructor(private apiService: ApiService) {}

  sendGeneral(
    request: ISendGeneralNotificationRequest,
  ): Observable<ISendNotificationResponse> {
    return this.apiService.post<ISendNotificationResponse>(
      `${this.resourceUrl}/send-general`,
      request,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  getRecipients(
    search: string,
    page: number,
    pageSize: number,
  ): Observable<INotificationRecipientsResponse> {
    return this.apiService.get<INotificationRecipientsResponse>(
      `${this.resourceUrl}/recipients`,
      { search: search || "", page, pageSize },
      AuthService.defaultTokenHeader().headers,
    );
  }

  getHistory(
    page: number,
    pageSize: number,
  ): Observable<INotificationHistoryResponse> {
    return this.apiService.get<INotificationHistoryResponse>(
      `${this.resourceUrl}/history`,
      { page, pageSize },
      AuthService.defaultTokenHeader().headers,
    );
  }
}
